import { Component, OnInit } from '@angular/core';
import { delay } from 'rxjs/operators';
import { OverlayService } from './overlay.service';

@Component({
    selector: 'oir-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.less']
})
export class OverlayComponent implements OnInit {
    visible: boolean;

    constructor(private readonly overlayService: OverlayService) { }

    ngOnInit(): void {
      // Delay to ensure change detection.
        this.overlayService.model.pipe(delay(0)).subscribe(visible => {
            if (visible !== undefined && visible !== null) {
                this.visible = visible;
                const bodyElement = document.getElementsByTagName('body')[0];
                if (bodyElement) {
                  if (this.visible) {
                    bodyElement.classList.add('no-overflow');
                  } else {
                    bodyElement.classList.remove('no-overflow');
                  }
                }
            }
        });
    }
}
